module.exports = __webpack_public_path__ + "img/add-friends-img.7dc352e5.png";